import {
    cleanCommonParams,
    mapAttachmentParams,
} from './common';

const mapCustomerListParams = (
    isCreate,
    {
        premier_access_group_id,
        agency_id,
        creator_id,
        agency,
        creator,
        premier_access_group,
        attachment,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            customer_list: {
                ...cleanCommonParams(params),
                ...mapAttachmentParams(isCreate, attachment),
            },
        });
    });
};

export { mapCustomerListParams };
